import LegalPageBlocks from './LegalPageBlocks'
import LegalPageCardBlock from './LegalPageCardBlock'

export { LegalPageBlocks, LegalPageCardBlock }
